import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {

  transform(arr: any, value: string, reverse?: boolean): any[] {

    if (!Array.isArray(arr)) {
      return;
    }

    arr.sort((a: any, b: any) => {
      if (a[value] < b[value]) {
        return -1;
      }
      else if (a[value] > b[value]) {
        return 1;
      }
      else {
        return 0;
      }
    });

    if (reverse) {
      arr = arr.reverse();
    }
    
    return arr;
  }

}
